module.exports = __webpack_public_path__ + "static/img/welcome-back.2e6e19f0.svg";